import { erpAxios } from '..';

const statusStorniran = async (data) => {
  const res = await erpAxios.post(`/statusZahtjeva/storniran`, data);
  return res;
};

export default statusStorniran;
